import sendRequest from "@/libs/sendRequest"

const experiences = {
    namespaced: true,
    state: {
        experience: {},
        experiences: [],
        error: false,
        last_page: null,
        total_pages: null,
        id_experience: null
    },
    getters: {
        getExperience: (state) => (state.experience),
        getExperiences: (state) => (state.experiences),
        getLastPage: (state) => (state.last_page),
        getTotalPages: (state) => (state.total_pages),
        getError: (state) => (state.error),
        getIdExperience: (state) => (state.id_experience)
    },
    mutations: {
        setExperience: (state, payload) => state.experience = payload,
        setExperiences: (state, payload) => state.experiences = payload,
        setLastPage: (state, payload) => state.last_page = payload,
        setTotalPages: (state, payload) => state.total_pages = payload,
        setError: (state, payload) => state.error = payload,
        setIdExperience: (state, payload) => state.id_experience = payload
    },
    actions: {
        list: async({commit, dispatch, rootGetters}, query) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('admin/experiences/experiences/list', 'GET', null, query, custom_headers)

            if(response.success && response.data) {
                if(query.datatable) {
                    commit('setExperiences', response.data.list.result)
                    commit('setTotalPages', response.data.list.total_pages)

                    if(response.data.list.total_pages == query.page) {
                        commit('setLastPage', true)
                    }
                    else {
                        commit('setLastPage', false)
                    }
                }
                else {
                    commit('setExperiences', response.data.list)
                }
                dispatch('hiddenLoading', null, { root: true })
            }
            else if(!response.success && response.errors) {
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', 'An error has occurred try later', { root: true })
            }
            else if(!response.success && !response.data) {
                dispatch('lostConection', null, { root: true })
            }
        },
        view: async({commit, dispatch, rootGetters}, query) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('admin/experiences/experiences/view', 'GET', null, query, custom_headers)

            if(response.success && response.data) {
                commit('setExperience', response.data.view)
                dispatch('hiddenLoading', null, { root: true })
            }
            else if(!response.success && response.errors) {
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', 'An error has occurred try later', { root: true })
            }
            else if(!response.success && !response.data) {
                dispatch('lostConection', null, { root: true })
            }
        },
        add: async({commit, dispatch, rootGetters}, data) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('admin/experiences/experiences/create_experience', 'PUT', data.body, data.query, custom_headers)

            if(response.success && response.data) {
                dispatch('showAlert', 'Experience saved successfully', { root: true })
                commit('setIdExperience', response.data.id)
                commit('setError', false)
            }
            else if(!response.success && response.errors) {
                let messages = []
                for(let error in response.errors) {
                    switch(response.errors[error].code) {
                        case 'error_empty_id_experience_category':
                            messages.push('Error: experience category required')
                            break
                        case 'error_empty_id_experience_duration':
                            messages.push('Error: experience duration required')
                            break
                        case 'error_empty_title':
                            messages.push('Error: title required')
                            break
                        case 'error_empty_cost':
                            messages.push('Error: costs required')
                            break
                        case 'error_empty_services':
                            messages.push('Error: services required')
                            break
                        case 'error_empty_amenities':
                            messages.push('Error: ameitires required')
                            break
                        case 'error_empty_schedules':
                            messages.push('Error: schedules required')
                            break
                        case 'error_experience_has_already_exist':
                            messages.push('Error: schedules required')
                            break
                        case 'error_init_schedule_invalid':
                            messages.push('Error: hour format must be 24hour ex: 09:00, 17:00')
                            break
                        default:
                            messages.push('An error has ocorred, try again later')
                            break
                    }
                }
                commit('setError', true)
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', messages, { root: true })
            }
            else if(!response.success && !response.data) {
                dispatch('lostConection', null, { root: true })
            }
        },
        addGallery: async({commit, dispatch, rootGetters}, data) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('admin/experiences/experiences/update_gallery', 'PUT', data.body, data.query, custom_headers)

            if(response.success && response.data) {
                dispatch('showAlert', 'Gallery saved successfully', { root: true })
                commit('setError', false)
            }
            else if(!response.success && response.errors) {
                let messages = []
                for(let error in response.errors) {
                    switch(response.errors[error].code) {
                        case 'error_empty_galleries':
                            messages.push('Error: At least one image is required')
                            break;
                        case 'error_must_be_select_a_cover_for_gallery':
                            messages.push('Error: Please select a image as experience cover')
                            break;
                        default:
                            messages.push('An error has ocurred, try again later')
                            break
                    }
                }
                commit('setError', true)
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', messages, { root: true })
            }
            else if(!response.success && !response.data) {
                dispatch('lostConection', null, { root: true })
            }
        },
        addExtraInformation: async({commit, dispatch, rootGetters}, data) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('admin/experiences/experiences/update_information', 'PUT', data.body, data.query, custom_headers)

            if(response.success && response.data) {
                dispatch('showAlert', 'Information saved successfully', { root: true })
                commit('setError', false)
            }
            else if(!response.success && response.errors) {
                let messages = []
                for(let error in response.errors) {
                    switch(response.errors[error].code) {
                        default:
                            messages.push('An error has ocurred, try again later')
                            break
                    }
                }
                commit('setError', true)
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', messages, { root: true })
            }
            else if(!response.success && !response.data) {
                dispatch('lostConection', null, { root: true })
            }
        },
        delete: async({commit, dispatch, rootGetters}, id) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('admin/experiences/experiences/delete','DELETE', null, { id_experience: id }, custom_headers)

            if(response.success && response.data) {
                dispatch('showAlert', 'Experiences deleted with success', { root: true })
                commit('setError', false)
            }
            else if(!response.success && response.errors) {
                commit('setError', true)
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', 'An error has ocurred, try again later', { root: true })
            }
            else if(!response.success && !response.data) {
                dispatch('lostConection', null, { root: true })
            }
        }
    }
}

export default experiences